import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/components/public/shared";
import { EnquiryProvider } from "@/components/public/EnquiryProvider";

import PublicLayout from "@/components/public/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Catering from "@/pages/Catering";
import FoodServices from "@/pages/FoodServices";
import Events from "@/pages/Events";
import Hospitality from "@/pages/Hospitality";
import Menu from "@/pages/Menu";
import Packages from "@/pages/Packages";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import { Privacy, Terms } from "@/pages/Legal";

import AdminLogin, { AuthCallback } from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Enquiries from "@/pages/admin/Enquiries";
import { EventsPipeline, BulkPipeline } from "@/pages/admin/Pipelines";
import MenuAdmin from "@/pages/admin/MenuAdmin";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import AdminActivity from "@/pages/admin/AdminActivity";
import { BrandsAdmin, BranchesAdmin, StaffAdmin, CctvAdmin, PackagesAdmin, ForecastAdmin, UsersAdmin, SettingsAdmin } from "@/pages/admin/Misc";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/catering" element={<Catering />} />
        <Route path="/food-services" element={<FoodServices />} />
        <Route path="/events" element={<Events />} />
        <Route path="/hospitality" element={<Hospitality />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Route>

      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="enquiries" element={<Enquiries />} />
        <Route path="events" element={<EventsPipeline />} />
        <Route path="bulk" element={<BulkPipeline />} />
        <Route path="menu" element={<MenuAdmin />} />
        <Route path="packages" element={<PackagesAdmin />} />
        <Route path="gallery" element={<GalleryAdmin />} />
        <Route path="brands" element={<BrandsAdmin />} />
        <Route path="branches" element={<BranchesAdmin />} />
        <Route path="staff" element={<StaffAdmin />} />
        <Route path="cctv" element={<CctvAdmin />} />
        <Route path="forecast" element={<ForecastAdmin />} />
        <Route path="users" element={<UsersAdmin />} />
        <Route path="activity" element={<AdminActivity />} />
        <Route path="settings" element={<SettingsAdmin />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <EnquiryProvider>
          <BrowserRouter>
            <AppRouter />
            <Toaster position="top-center" richColors />
          </BrowserRouter>
        </EnquiryProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}
